import { useLazyQuery } from '@apollo/client';
import { CurrentUser } from 'graphql/query/__generated__/CurrentUser';
import { CURRENT_USER_QUERY } from 'graphql/query/userQuery';
import { getLocalStorage } from 'libs/utils/logic/ui/systemLogic';
import { useContext, useEffect } from 'react';
import { GlobalContext } from 'session/state/context';
import { setDbLikelyCrashed, setLoggedUser, setUserChecked } from 'session/state/user/userActions';
import { LOCAL_STORAGE_AUTH_HEADER_KEY } from 'static/config/coreConfig';

export const GlobalUser = (): JSX.Element => {
    const { dispatch } = useContext(GlobalContext);

    const [currentUser] = useLazyQuery<CurrentUser>(CURRENT_USER_QUERY, {
        onCompleted: (result) => {
            dispatch(setLoggedUser(result.currentUser));
            dispatch(setUserChecked(true));
        },
        onError: (error) => {
            if (error.networkError && 'statusCode' in error.networkError) {
                dispatch(setLoggedUser(null));
            }
            dispatch(setDbLikelyCrashed(true));
        }
    });

    useEffect(() => {
        if (getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY)) {
            currentUser();
        } else {
            setLoggedUser(null);
            dispatch(setUserChecked(true));
        }
    }, []);

    return <></>;
};
